var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D2D",
    d: "M15.129 13.938c-1.02 0-1.477.562-3.129.562-1.687 0-2.145-.562-3.164-.562-2.602 0-4.711 2.144-4.711 4.746v.878c0 .95.738 1.688 1.688 1.688h12.375c.914 0 1.687-.738 1.687-1.687v-.88c0-2.601-2.145-4.745-4.746-4.745m3.059 5.624H5.813v-.878c0-1.688 1.335-3.059 3.023-3.059.527 0 1.336.563 3.164.563 1.793 0 2.602-.563 3.129-.563a3.06 3.06 0 0 1 3.059 3.059zM12 13.375a5.064 5.064 0 0 0 5.063-5.062c0-2.778-2.286-5.063-5.063-5.063a5.064 5.064 0 0 0-5.062 5.063A5.04 5.04 0 0 0 12 13.375m0-8.437c1.828 0 3.375 1.546 3.375 3.375 0 1.863-1.547 3.374-3.375 3.374a3.376 3.376 0 0 1-3.375-3.374c0-1.829 1.512-3.376 3.375-3.376"
  })));
};
export default SvgUser;